export default "__VITE_ASSET__DBWZ_Hkf__"